import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { GRAY_COLORS } from '../../../lib/stitches'
import { useTreeState } from '../../../stores/Root'
import { Row } from '../../core/Components'
import Playhead from './Playhead'

interface RecordMarkProps {
  height: string
  fill?: string
  label?: string
}
export const RecordMark: FC<RecordMarkProps> = ({ height, fill, label }) => {
  const borderColor = fill || 'var(--studio-medium-strong)'
  return (
    <Row
      css={{
        height: height,
        flex: '1',
        justifyContent: 'end',
        borderRight: `1px solid ${borderColor}`,
        color: 'var(--studio-medium-strong)',
        fontSize: '0.8rem',
        verticalAlign: 'bottom',
        overflowX: 'visible'
      }}
      unselectable
    >
      <span style={{ paddingRight: '3px' }}>{label || ' '}</span>
    </Row>
  )
}

const RecordMarkSet = ({ height, width, item }) => {
  return (
    <Row
      css={{
        borderBottom: '1px solid var(--studio-medium)',
        minWidth: `${width}px`,
        alignItems: 'end',
        backgroundColor: GRAY_COLORS.gray01
      }}
    >
      <RecordMark height={'calc(' + height + ' / 8)'} />
      <RecordMark height={'calc(' + height + ' / 4)'} />
      <RecordMark height={'calc(' + height + ' / 8)'} />
      <RecordMark height={'calc(' + height + ' / 2)'} />
      <RecordMark height={'calc(' + height + ' / 8)'} />
      <RecordMark height={'calc(' + height + ' / 4)'} />
      <RecordMark height={'calc(' + height + ' / 8)'} />
      <RecordMark height={'calc(' + height + ' / 1)'} label={item + 1} />
    </Row>
  )
}

interface RecordMarksProps {
  height: string
  width: string
}
const RecordMarks: FC<RecordMarksProps> = observer(({ height, width }) => {
  const { studio } = useTreeState()
  const arrLength = studio.song.songDisplayLength + studio.extraBarsCount
  return (
    <>
      {Array.from(Array(arrLength).keys()).map((item, index) => (
        <RecordMarkSet width={width} height={height} item={item} key={item} />
      ))}
    </>
  )
})

const RecordMarker = ({ height, setPlayheadCoords, instrumentLoopWidthPX }) => {
  return (
    <Row
      className="align-items-end sticky-top"
      style={{
        height: height,
        backgroundColor: GRAY_COLORS.gray01,
        overflowY: 'visible',
        overflowX: 'visible',
        zIndex: '10'
      }}
    >
      <RecordMarks height={height} width={instrumentLoopWidthPX} />

      <Playhead isGhostPlayhead={true} instrumentLoopWidthPX={instrumentLoopWidthPX} />
      <Playhead
        setPlayheadCoords={setPlayheadCoords}
        instrumentLoopWidthPX={instrumentLoopWidthPX}
      />
    </Row>
  )
}

export default RecordMarker
